import { ApolloCache, gql } from '@apollo/client';

import { reconcileFindsInCache } from './getMyFindsQuery';
import { updateFindTagAssignmentInCache } from './getMyFindTagAssignmentsQuery';

export const UPDATE_FINDS_MUTATION = gql`
  mutation UpdateFindsMutation($ids: [String!]!, $find: BatchFindInput!) {
    updateFinds(ids: $ids, find: $find) {
      ... on UpdateFindsSuccess {
        updatedIds
        skippedIds
      }
      ... on ValidationError {
        errors {
          error
          path
        }
      }
    }
  }
`;

export interface BatchFindCacheUpdate {
  foundAt?: string | null;
  groupIds?: string[] | null;
  material?: string | null;
  era?: string | null;
  siteId?: string | null;
  tags?: string[];
  type?: string | null;
}

export const updateBatchFindsInCache = (
  cache: ApolloCache<unknown>,
  findIds: readonly string[],
  patch: BatchFindCacheUpdate
) => {
  findIds.forEach((id) => {
    const cacheId = cache.identify({ __typename: 'Find', id });

    if (!cacheId) {
      return;
    }

    let mergedTags: string[] | undefined;
    const fields = Object.fromEntries(
      Object.entries(patch)
        .filter(([key]) => key !== 'tags')
        .map(([key, value]) => [key, () => value])
    );

    if (patch.tags) {
      fields.tags = (existing: readonly string[] = []) => {
        mergedTags = [...new Set([...existing, ...patch.tags!])];

        return mergedTags;
      };
    }

    fields.updatedAt = () => new Date().toISOString();
    cache.modify({ id: cacheId, fields });

    if (mergedTags) {
      updateFindTagAssignmentInCache(cache, { id, tags: mergedTags });
    }
  });

  reconcileFindsInCache(cache, findIds);
};
